/* Hueban motion layer.
   Uses Motion (motion.dev, MIT) mini animate + spring + stagger, loaded from
   assets/hueban-motion.js. Viewport detection stays on native
   IntersectionObserver, which is free and avoids Motion's heavier inView.
   Degrades to a plain CSS class if Motion is missing. */
(function () {
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (REDUCED) document.documentElement.classList.add('no-anim');

  function M() { return window.HuebanMotion || null; }

  function revealGroup(el) {
    var m = M();
    // Children that should stagger in: direct grid/list items, else the block itself.
    var kids = el.querySelectorAll(
      '.hb-badges > li, .hb-pains > li, .hb-models > .hb-model, .hb-revs > .hb-rev, .hb-assure > div, .hb-beat'
    );
    if (!m || REDUCED || !kids.length) { el.classList.add('in'); return; }

    el.classList.add('in');
    m.animate(
      kids,
      { opacity: [0, 1], transform: ['translateY(16px)', 'translateY(0px)'] },
      { duration: 0.55, delay: m.stagger(0.06), easing: [0.23, 1, 0.32, 1] }
    );
  }

  function countUp(el) {
    el.setAttribute('data-done', '1');
    var target = parseFloat(el.getAttribute('data-hb-count')) || 0;
    var suffix = el.getAttribute('data-hb-suffix') || '';
    // The end state is always the string the server rendered, so it can never
    // differ from the no-JS value or drift with the browser's number locale.
    var endText = el.getAttribute('data-hb-value');
    if (endText === null || endText === '') endText = target.toLocaleString() + suffix;
    if (REDUCED) { el.textContent = endText; return; }
    var m = M();
    if (m) {
      m.animate(0, target, {
        duration: 1.1,
        easing: [0.23, 1, 0.32, 1],
        onUpdate: function (v) { el.textContent = Math.round(v).toLocaleString() + suffix; }
      });
      setTimeout(function () { el.textContent = endText; }, 1250);
      return;
    }
    var t0 = null;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min((ts - t0) / 1100, 1);
      if (p < 1) {
        el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3))).toLocaleString() + suffix;
        requestAnimationFrame(step);
      } else {
        el.textContent = endText;
      }
    }
    requestAnimationFrame(step);
  }

  /* Spring press on every pill button and frame card. */
  function springPress() {
    var m = M();
    if (!m || REDUCED) return;
    var targets = document.querySelectorAll('.hb-model, .button, button.btn, a.btn');
    [].forEach.call(targets, function (el) {
      if (el._hbSpring) return;
      el._hbSpring = 1;
      el.addEventListener('pointerdown', function () {
        m.animate(el, { transform: 'scale(0.97)' }, { duration: 0.12 });
      });
      ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (ev) {
        el.addEventListener(ev, function () {
          m.animate(el, { transform: 'scale(1)' }, { type: m.spring, stiffness: 420, damping: 22 });
        });
      });
    });
  }


  /* Jump links preselect the frame they name, then scroll to the frame grid. */
  function wireJump() {
    var links = document.querySelectorAll('[data-hb-frame]');
    if (!links.length) return;
    [].forEach.call(links, function (a) {
      if (a._hbJump) return;
      a._hbJump = 1;
      a.addEventListener('click', function (e) {
        var target = document.getElementById('frames');
        // No frame grid on this page: leave the raw href alone so the link still works.
        if (!target) return;
        e.preventDefault();

        // Preselect the variant through the picker so price, media and the form all follow.
        var vid = a.getAttribute('data-hb-variant');
        if (vid) {
          var radio = document.querySelector('input[type="radio"][data-variant-id="' + vid + '"]');
          if (radio && !radio.checked) radio.click();
        }

        target.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'start' });

        var grid = document.getElementById('fgrid');
        if (!grid) return;
        var want = (a.getAttribute('data-hb-frame') || '').trim().toLowerCase();
        var match = null;
        [].forEach.call(grid.children, function (b) {
          if ((b.getAttribute('data-n') || '').trim().toLowerCase() === want) match = b;
        });
        if (!match) return;

        if (match._hbPulse) clearTimeout(match._hbPulse);
        match.classList.add('is-hb-target');
        match._hbPulse = setTimeout(function () { match.classList.remove('is-hb-target'); }, 1400);

        var m = M();
        if (m && !REDUCED) {
          m.animate(match, { transform: ['scale(1)', 'scale(1.04)', 'scale(1)'] },
            { duration: 0.5, easing: [0.23, 1, 0.32, 1] });
        }
      });
    });
  }

  /* Buy links land on the add to cart control when it exists, on the buy section otherwise. */
  function wireBuy() {
    var links = document.querySelectorAll('a[href$="#buy"]');
    if (!links.length) return;
    [].forEach.call(links, function (a) {
      if (a._hbBuy) return;
      a._hbBuy = 1;
      a.addEventListener('click', function (e) {
        var section = document.getElementById('buy');
        // Homepage: the buy box is a featured product section without the anchor.
        if (!section) {
          var pf = document.querySelector('product-form-component');
          section = pf ? (pf.closest('.shopify-section') || pf) : null;
        }
        // No buy section on this page: leave the raw href alone so the link still works.
        if (!section) return;
        var form = section.querySelector('.add-to-cart-button, [name="add"], .product-form-buttons');
        var target = form || section;
        e.preventDefault();
        target.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: form ? 'center' : 'start' });
        if (history.replaceState) history.replaceState(null, '', '#buy');
      });
    });
  }


  /* Pair choice: picking 1 or 2 pairs sets the product form quantity. */
  function pairsQty(fs) {
    var root = fs.closest('.shopify-section') || document;
    return root.querySelector('product-form-component input[name="quantity"]') ||
           root.querySelector('input[name="quantity"]');
  }
  function applyPairs(fs) {
    var picked = fs.querySelector('input[type="radio"]:checked');
    var q = pairsQty(fs);
    if (!picked || !q) return;
    if (String(q.value) !== picked.value) {
      q.value = picked.value;
      q.dispatchEvent(new Event('input', { bubbles: true }));
      q.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  function wirePairs() {
    [].forEach.call(document.querySelectorAll('[data-hb-pairs]'), function (fs) {
      var root = fs.closest('.shopify-section');
      if (root) root.classList.add('hb-has-pairs');
      if (fs._hbPairs) return;
      fs._hbPairs = 1;
      fs.addEventListener('change', function () { applyPairs(fs); });
    });
  }
  // A frame change re-renders parts of the buy box; keep quantity in step with the choice.
  document.addEventListener('variant:update', function () {
    setTimeout(function () {
      wirePairs();
      [].forEach.call(document.querySelectorAll('[data-hb-pairs]'), applyPairs);
    }, 60);
  });

  /* Drawer upsell: add one more unit, then let Horizon re-render the drawer
     through its own cart:update event, exactly as Add to cart does. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-hb-upsell-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var box = btn.closest('[data-hb-upsell]');
    var sel = box && box.querySelector('[data-hb-upsell-select]');
    var err = box && box.querySelector('[data-hb-upsell-err]');
    var id = Number(sel ? sel.value : btn.getAttribute('data-variant'));
    var ids = [].map.call(document.querySelectorAll('cart-items-component'), function (c) {
      return c.dataset.sectionId;
    }).filter(Boolean);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    if (err) err.hidden = true;
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: ids.join(',') })
    })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function (added) {
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var ev = new Event('cart:update', { bubbles: true });
            ev.detail = { resource: cart, sourceId: 'hb-upsell',
              data: { source: 'hb-upsell', itemCount: cart.item_count, sections: added.sections || {} } };
            document.dispatchEvent(ev);
          });
      })
      .catch(function () {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        if (err) err.hidden = false;
      });
  });

  function init() {
    var rev = document.querySelectorAll('.hb-reveal:not(.in)');
    var vh = window.innerHeight || 800;
    [].forEach.call(rev, function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) el.classList.add('in');
    });
    rev = document.querySelectorAll('.hb-reveal:not(.in)');
    if (!REDUCED) document.documentElement.classList.add('hb-anim');
    if (!REDUCED && 'IntersectionObserver' in window) {
      var ro = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { revealGroup(e.target); ro.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      [].forEach.call(rev, function (el) { ro.observe(el); });
    } else {
      [].forEach.call(rev, function (el) { el.classList.add('in'); });
    }

    // Stats: no count-up. The server-rendered number is the only state, so crawlers,
    // link previews, slow phones and reduced-motion users all see the real value.

    springPress();
    wirePairs();
    wireJump();
    wireBuy();
    window.__hbReady = true;
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();
